export default __webpack_public_path__ + "static/media/live-chat-active.5bbe443a.webp";